import Image from "next/image";
import styles from "./categorySearch.module.scss";
import { RootCategoryModel } from "../../../models/root-category.model";
import AllCategory from "../../../../shared-assets/Svg/Category.svg";
import { Swiper, SwiperSlide } from "swiper/react";

type CategorySearch = {
  selectedCategory: number;
  categories: RootCategoryModel[] | number[];
  handleSetCategory: (category?: number) => void;
};

export const CategorySearch = ({
  selectedCategory,
  categories,
  handleSetCategory
}: CategorySearch) => {
  return (
    <div className={styles.categoryWrapper}>
      <Swiper
        className={`${styles.swiper}`}
        autoHeight={false}
        slidesPerView="auto"
        slidesPerGroup={2}
        dir="rtl"
        spaceBetween={9}
      >
        {categories?.length > 0 &&
          categories?.map((category, index) => (
            <SwiperSlide
              key={"swip-prod-" + category.id}
              className={`${styles.swiperSlideCustom}`}
              virtualIndex={index}
            >
              <div
                className={`${styles.categoryButton} ${
                  selectedCategory === category?.id && styles.active
                } `}
                onClick={() => handleSetCategory(category.id)}
              >
                <span className={styles.icon}>
                  {index === 0 ? (
                    <AllCategory />
                  ) : (
                    <Image src={category?.avatar} width={16} height={16} />
                  )}
                </span>
                {category?.title}
              </div>
            </SwiperSlide>
          ))}
      </Swiper>
    </div>
  );
};
